import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer"
import Graphic from "@arcgis/core/Graphic"

interface GraphicsLayerData {
  handle: GraphicsLayerHandle
  map: __esri.Map
  view: __esri.MapView
  layer: GraphicsLayer
  graphics: Graphic[]
  nextGraphicHandle: number
}
export type GraphicsLayerHandle = number
export const NULL_LAYER_HANDLE: GraphicsLayerHandle = -1
export const NULL_GRAPHIC_HANDLE: GraphicHandle = -1
export type GraphicHandle = number

let graphicsLayers: GraphicsLayerData[] = []
let nextLayerHandle = 0


export const createGraphicsLayer = (map: __esri.Map, view: __esri.MapView): GraphicsLayerHandle => {
  const layer = new GraphicsLayer()
  map.add(layer)
  const graphicsLayerData: GraphicsLayerData = {
    handle: nextLayerHandle,
    layer,
    map,
    view,
    graphics: [],
    nextGraphicHandle: 0
  }
  graphicsLayers.push(graphicsLayerData)
  return nextLayerHandle++
}

export const createGraphic = (layerHandle: GraphicsLayerHandle, attributes: any, geometry: __esri.Geometry, symbol: __esri.Symbol): GraphicHandle => {
  const graphic = new Graphic({ attributes, geometry, symbol })
  const layerData = graphicsLayers[layerHandle]
  layerData.graphics.push(graphic)
  return layerData.nextGraphicHandle++
}

export const addGraphic = (layerHandle: GraphicsLayerHandle, graphicHandle: GraphicHandle) => {
  const layerData = graphicsLayers[layerHandle]
  const graphic = layerData.graphics[graphicHandle]
  layerData.layer.graphics.add(graphic)
}

export const addGraphics = (layerHandle: GraphicsLayerHandle, graphicHandles: GraphicHandle[]) => {
  const layerData = graphicsLayers[layerHandle]
  const graphics = graphicHandles.map(handle => layerData.graphics[handle])
  layerData.layer.graphics.addMany(graphics)
}

export const updateGraphicAttributes = (layerHandle: GraphicsLayerHandle, graphicHandle: GraphicHandle, modifierFunction: (attributes: any) => any) => {
  const layerData = graphicsLayers[layerHandle]
  const graphic = layerData.graphics[graphicHandle]
  graphic.attributes = modifierFunction(graphic.attributes)
}

export const updateGraphicSymbol = (layerHandle: GraphicsLayerHandle, graphicHandle: GraphicHandle, symbol: __esri.Symbol) => {
  const layerData = graphicsLayers[layerHandle]
  const graphic = layerData.graphics[graphicHandle]
  graphic.symbol = symbol
}

export const getGraphic = (layerHandle: GraphicsLayerHandle, graphicHandle: GraphicHandle) => {
  const layerData = graphicsLayers[layerHandle]
  return layerData.graphics[graphicHandle]
}

export const removeGraphic = (layerHandle: GraphicsLayerHandle, graphicHandle: GraphicHandle) => {
  const layerData = graphicsLayers[layerHandle]
  const graphic = layerData.graphics[graphicHandle]
  layerData.layer.graphics.remove(graphic)
}

export const clearGraphics = (layerHandle: GraphicsLayerHandle) => {
  const layerData = graphicsLayers[layerHandle]
  layerData.layer.graphics.removeAll()
  layerData.graphics = []
  layerData.nextGraphicHandle = 0
}